import AccountService from "../../service/AccountService";


export const state = {
  allAccountsOriginal: [],
  allAccounts: [],
  allActivities: [],
  accactivities: [],
  beneficiaries: [],
  accountoption: [],
  statements: [],
  accountDetails: {},
  accountLoading: false,
  response: {},
  account: "",
  totalsum: {},
  retentionData: {},
  revenueData: {},
  currentAccount: {},
  formatter: new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "NGN"
  }),
  accountCards: [
    {
      id: 0,
      name: "TOTAL BALANCE",
      number: "NGN 0.00" ,
      color: "bg-gray-500"
    },
    {
      id: 1,
      name: "TOTAL ACCOUNT",
      number: "NGN 0.00" ,
      color: "bg-indigo"
    },
    {
      id: 2,
      name: "TOTAL B.BALANCE",
      number: "NGN 0.00",
      color: "bg-success"
    },
    {
      id: 3,
      name: "TOTAL OD.LIMIT",
      number: "NGN 0.00",
      color: "bg-black-6"
    }

  ],
  accounts: [
    { account: "2083474695", bank: "Zenith Bank" },
    { account: "2083474699", bank: "Rubies" }
  ]
};

export const getters = {
  totalBalance : state => state.formatter.format(state.allAccounts.reduce((acc, account) =>  acc + account.availablebalance, 0.0)),

  getByAccount: state => accno => state.allActivities.filter(trans => trans.account === accno),

  beneficiaryOptions: state => state.beneficiaries.map(ben => ({text: `${ben.accountname} - ${ben.accountnumber} : ${ben.bankname}`, value: ben})),

  totalAccount: state => {
    return state.allAccounts.length
  },

  getformattedaccounts: state => {
    return state.allAccounts.forEach(acc => acc['availablebalance'] = state.formatter.format(acc.availablebalance))
  }
};

export const mutations = {

  COMMIT_ACCOUNT_OPTION:(state, payload) =>{
    //const items  =  payload.filter(acc => acc.availablebalance > 0);
    state.accountoption = payload.map(acc => {
      const accounts = {};
      accounts.text = acc.accountname + ' '  + acc.accountno + ' bal:' +acc.availablebalance;
      accounts['value'] = {'accountname': acc.accountname, 'accountnumber': acc.accountno};
      return accounts;
    })
  },

  UPDATE_ACTIVITIES:(state, payload) =>{
    //const items  =  payload.filter(acc => acc.availablebalance > 0);
    state.accactivities = payload
  },

  UPDATE_BENEFICIARIES:(state, payload) =>{
    state.beneficiaries = payload
  },

  COMMIT_ACCOUNT_ACTIVITIES:(state, payload) =>{
    //const items  =  payload.filter(acc => acc.availablebalance > 0);
    state.accactivities = state.allActivities.filter(acc => acc.account === payload.accountnumber)
  },

  updateAllAccounts: (state, payload) => {
    // console.log("Entered Mutation", payload);
    state.allAccounts = payload;
  },

  UPDATE_ACCOUNT_BALANCES: (state) => {
    state.allAccounts =  state.allAccounts.forEach(acc => acc['availablebalance'] = state.formatter.format(acc.availablebalance))
  },

  UPDATE_STATEMENTS: (state, payload) => {
    // console.log("Entered Mutation", payload);
    state.statements =  payload
  },

  updateAllActivities: (state, payload) => {
    // console.log("Entered Mutation", payload);
    state.allActivities = payload;
  },
  updateAllAccountsOriginal: (state, payload) => {
    // console.log("Entered Mutation", payload);
    state.allAccountsOriginal = payload;
  },
  updateCardsAccount: (state, payload) => {
    // console.log("Entered Mutation", payload);
    state.accountCards = payload;
  },
  updateAccountDetails: (state, payload) => {
    // console.log("Entered Mutation", payload);
    state.accountDetails = payload;
  },
  updateAccountLoading: (state, payload) => {
    // console.log('Entered Mutation', payload);
    state.accountLoading = payload;
  },
 UPDATE_CURRENT_ACCOUNT: (state, payload) => {
    // console.log('Entered Mutation', payload);
    console.log("inside update mutation", payload);
    state.currentAccount = payload;
  },
  UPDATE_RET_DATA: (state, payload) => {
    // console.log('Entered Mutation', payload);
    state.retentionData = payload;
  },
  UPDATE_REV_DATA: (state, payload) => {
    // console.log('Entered Mutation', payload);
    state.revenueData = payload;
  },
  UPDATE_SUM_TOTAL: (state, payload) => {
    // console.log('Entered Mutation', payload);
    state.totalsum = payload;
  }
};

export const actions = {

  updateStatements: ({ commit }, payload) => {
    commit("UPDATE_STATEMENTS", payload);
  },
  getAllAccount: ({ commit }, payload) => {
    if (state.allAccounts.length < 1)
        commit("updateAccountLoading", true);
    return (
      AccountService.callCbankReadAllAccountApi(payload)
        .then(response => {
          let responseData = response.data;
          commit("updateAccountLoading", false);
          if (responseData.responsecode === "00") {
            let data = responseData.accountlist;
            commit("updateAllActivities", responseData.transactionlist);
            commit("UPDATE_ACTIVITIES", responseData.transactionlist);
            //console.log(responseData.transactionlist.filter(act => act.account === '0000000008'))
            // console.log(responseData.transactionlist);
            // console.log(data.reduce((acc, account) =>  acc + parseFloat(account.availablebalance), 0.0));
            commit("updateAllAccounts", data);
            commit("COMMIT_ACCOUNT_OPTION", data)
            //commit("UPDATE_STATEMENTS", responseData.transactionlist);
            commit("updateAccountDetails", responseData);
            //commit("updateAllAccountsOriginal", responseData.accounts);
            // console.log('ent>>>>>>>>>>>')
            commit("updateCardsAccount", [
              {
                id: 0,
                name: "TOTAL BALANCE",
                number: state.formatter.format(data.reduce((acc, account) =>  acc + parseFloat(account.availablebalance), 0.0)),
                color: "bg-gray-500"
              },
              {
                id: 1,
                name: "TOTAL NUMBER OF ACCOUNTS",
                number: data.length,
                color: "bg-indigo"
              },
              {
                id: 2,
                name: "TOTAL MINIMUM BALANCE",
                number: state.formatter.format(0),
                color: "bg-success"
              },
              {
                id: 3,
                name: "TOTAL OD.LIMIT",
                number: state.formatter.format(0),
                color: "bg-black-6"
              }
            ]);
            // console.log(state.cards);
            return responseData
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          // commit("updateCompaniesLoading", false)
          // alert(error)
          // throw error;
        })
    );
  },

  updateAccountsNew: ({ commit }, payload) => {
    commit("updateAccountLoading", true);
    return (
      AccountService.callGetAccountsApi(payload)
        .then(response => {
          let responseData = response.data;
          commit("updateAccountLoading", false);
          if (response.data.responsecode === "00") {
            //commit("updateIsAccountsUpt", true)
            //console.log("callupdateAccountsApi responseData ==>>", responseData);
            commit("updateAccounts", responseData.data);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          //commit("updateAccountLoading", false)
          // alert(error)
        })
    );
  },

  updateChartData: ({ commit }, payload) => {
    if (JSON.stringify(state.revenueData) === '{}')
      commit("updateAccountLoading", true);
    return (
      AccountService.callCbankReadAllAccountApi(payload)
        .then(response => {
          let result = response.data;
          if (response.data.responsecode === "00") {
            const account =   result.accountlist.filter(acc => acc.availablebalance > 0).map(acc => acc.accountno);
            const accdata =   result.accountlist.filter(acc => acc.availablebalance > 0).map( acc => acc.availablebalance);
            commit("UPDATE_RET_DATA", {
              labels: account,
              datasets: [{
                label: 'Balances',
                data: accdata,
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)'
                ],
                borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)'
                ],
                borderWidth: 1
              }]
            });
            commit("updateAllAccounts", result.accountlist);
            commit("updateAllActivities", result.transactionlist);
            const label = [...new Set(result.transactionlist.map(trans => trans.eventdate.substring(0, 10)))].reverse();
            const data = label.map(item =>
                result.transactionlist.filter(trans => trans.eventdate.substring(0, 10) === item).reduce((init, curr) => (init += parseInt(curr.amount)), 0)
            );
            commit("UPDATE_REV_DATA", {
              labels: label,
              datasets: [{
                label: 'Amount Spent',
                data: data,
                heigth: 400,
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)'
                ],
                borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)'
                ],
                borderWidth: 1
              }]
            });
            const totalsum = {};
            totalsum.sum  = result.accountlist.reduce((init, curr) => init+=parseInt(curr.availablebalance), 0);
            totalsum.max = Math.max(...accdata);
            totalsum.retmin = Math.min(...data);
            totalsum.retmax = Math.max(...data);
            commit("UPDATE_SUM_TOTAL", totalsum)
          }
          commit("updateAccountLoading", false);
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          commit("updateAccountLoading", false);
          alert(error)
        })
    );
  },

  getAccountStatements: ({ commit }, payload) => {
    commit("updateAccountLoading", true);
    return (
        AccountService.fetchStatementsApi(payload)
            .then(response => {
              if(response.data.responsecode === "00"){
                //console.log(response.data);
                commit("UPDATE_STATEMENTS", response.data.transactionlist);
                return response.data.transactionlist
              }
              commit("updateAccountLoading", false);
            })
            .catch(error => { alert(error)})
    );
  },

  getCompanyBeneficiaries: ({ commit }, payload) => {
    commit("updateAccountLoading", true);
    return (
        AccountService.callGetCompanyBeneficiaries(payload)
            .then(response => {
              if(response.data.responsecode === "00"){
                //console.log(response.data);
                commit("UPDATE_BENEFICIARIES", response.data.data);
                return response.data.data
              }
              commit("updateAccountLoading", false);
            })
            .catch(error => { alert(error)})
    );


  },





  reset: ({ commit }, payload) => {
    commit("reset", payload);
  }
};
